import type { PluginKey as PluginKeyType } from '@atlaskit/editor-prosemirror/state';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIImageGenerationPMPluginState } from './main';

export const pluginKey: PluginKeyType<AIImageGenerationPMPluginState> =
	new PluginKey<AIImageGenerationPMPluginState>('aiImageGenerationPlugin');
